/**
 * DevExtreme (viz/circular_gauge.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./gauges/circular_gauge");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme/viz/circular_gauge.js
// module id = ../../../../devextreme/viz/circular_gauge.js
// module chunks = 3